import StatusTag from '@/components/_common/StatusTag';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { useSpedAssessmentConsult } from '@/core/domain/sped/sped-assessment/sped-assessment.hooks';
import {
  QUERY_SPED_DOCUMENT_INUTILIZATIONS,
  QUERY_SPED_DOCUMENT_INVOICES,
  QUERY_SPED_DOCUMENT_PURCHASES,
} from '@/core/domain/sped/sped-documents/sped-documents.hooks';
import {
  SpedDocumentStatusColor,
  SpedDocumentStatusLabel,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Alert, Button, Modal } from 'antd';

export default function SpedDocumentCheckResults() {
  const spedDocument = useSpedDocumentContext();
  const queryChanel = useQueryChanel();

  const hasPermission = hasPermissions([
    Authorities.SPED_DOCUMENT_CONSULT_ANALYSIS,
  ]);

  const assesmentConsult = useSpedAssessmentConsult();

  const consult = async () => {
    if (!spedDocument) return;

    const result = await assesmentConsult.mutateAsync(spedDocument.id);

    queryChanel({
      invalidateQueries: [
        [QUERY_SPED_DOCUMENT_INUTILIZATIONS],
        [QUERY_SPED_DOCUMENT_PURCHASES],
        [QUERY_SPED_DOCUMENT_INVOICES],
      ],
    });

    if (!result.errors && result.message) {
      Modal.info({
        title: 'Consulta de apuração do documento SPED',
        content: (
          <>
            <StatusTag
              color={SpedDocumentStatusColor[result.status]}
              label={SpedDocumentStatusLabel[result.status]}
            />

            <p>{result.message}</p>
          </>
        ),
      });
    } else if (result.errors) {
      Modal.error({
        title: 'Consulta de apuração do documento SPED',
        content: (
          <>
            <StatusTag
              color={SpedDocumentStatusColor[result.status]}
              label={SpedDocumentStatusLabel[result.status]}
            />

            {!!result.message && <p>{result.message}</p>}

            <Alert type="error" description={result.errors} message="Erro" />
          </>
        ),
      });
    }
  };

  return (
    <Button
      type="primary"
      onClick={consult}
      loading={assesmentConsult.isLoading}
      disabled={!hasPermission}
    >
      {assesmentConsult.isLoading ? 'Consultando...' : 'Consultar apuração'}
    </Button>
  );
}
